import { render } from "./Captcha.vue?vue&type=template&id=78b89292&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=78b89292&lang=less&scoped=true"

import exportComponent from "G:\\Teamax\\雅丽洁支付\\yalgetoms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b89292"]])

export default __exports__